import PlaystyleIcon from '@/assets/icons/gamepad.svg?react';
import VibeIcon from '@/assets/icons/star.svg?react';

export const PROFILE_ICONS = {
  vibe: VibeIcon,
  gameplay: PlaystyleIcon,
} as const;
